import RoleUsersTable from "./RoleUsersTable";
import RolePermissionsTable from "./RolePermissionsTable";
import OverviewTabContent from "../../../../../../../shared/components/overview-panel/OverviewTabContent";
import OverviewTabs from "../../../../../../../shared/components/overview-panel/OverviewTabs";

const RoleInfoTabMenu = ({ users, permissions }) => {
  const tabs = [
    {
      trigger: { value: "users", label: "Usuarios" },
      content: (
        <OverviewTabContent
          value="users"
          title="Usuarios"
          description="Usuarios con este rol asignado"
        >
          <RoleUsersTable data={users} />
        </OverviewTabContent>
      ),
    },
    {
      trigger: { value: "permissions", label: "Permisos" },
      content: (
        <OverviewTabContent
          value="permissions"
          title="Permisos"
          description="Permisos asignados al rol"
        >
          <RolePermissionsTable data={permissions} />
        </OverviewTabContent>
      ),
    },
  ];

  return (
    <div className="grid flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0 md:gap-8">
      <OverviewTabs tabs={tabs} defaultTabValue="users" />
    </div>
  );
};

export default RoleInfoTabMenu;
